/**
 * 361 Sleep — Hero cinematic entrance
 * Runs once on load: brand → Arabic copy → commerce
 * (price, BNPL, CTA). Respects prefers-reduced-motion.
 * Locks section height after first paint so mobile browser
 * chrome show/hide can't resize the cover image (looks like zoom).
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function whenGsap(fn) {
    if (window.gsap) {
      fn(window.gsap);
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (window.gsap) {
        clearInterval(timer);
        fn(window.gsap);
      } else if (tries > 80) {
        clearInterval(timer);
        document.querySelectorAll('.hero361[data-hero-pending], .heroDrNight[data-hero-pending]').forEach(function (el) {
          el.removeAttribute('data-hero-pending');
        });
      }
    }, 50);
  }

  function showSection(section) {
    section.removeAttribute('data-hero-pending');
    section.setAttribute('data-hero-ready', '');
  }

  function lockHeight(section) {
    section.style.height = '';
    section.style.minHeight = '';
    // Force layout, then freeze px height so toolbar resize can't reflow cover crop.
    var h = Math.round(section.getBoundingClientRect().height);
    if (h > 0) {
      section.style.height = h + 'px';
      section.style.minHeight = h + 'px';
    }
  }

  function initSection(section, gsap) {
    if (section._hero361Done) return;
    section._hero361Done = true;

    var brand = section.querySelector('[data-hero-brand]');
    var copy = section.querySelector('[data-hero-copy]');
    var titleAr = section.querySelector('[data-hero-title-ar]');
    var subtitle = section.querySelector('[data-hero-subtitle]');
    var desc = section.querySelector('[data-hero-desc]');
    var price = section.querySelector('[data-hero-price]');
    var bnpl = section.querySelector('[data-hero-bnpl]');
    var cta = section.querySelector('[data-hero-cta]');

    if (section._hero361Ctx) {
      section._hero361Ctx.revert();
      section._hero361Ctx = null;
    }

    lockHeight(section);

    var ctx = gsap.context(function () {
      var mm = gsap.matchMedia();

      mm.add('(prefers-reduced-motion: reduce)', function () {
        showSection(section);
        gsap.set(
          [brand, copy, titleAr, subtitle, desc, price, bnpl, cta].filter(Boolean),
          { clearProps: 'all' }
        );
      });

      mm.add('(prefers-reduced-motion: no-preference)', function () {
        var rise = [brand, titleAr, subtitle, desc, price, bnpl, cta].filter(Boolean);

        gsap.set(rise, { opacity: 0, y: 22 });

        showSection(section);

        var tl = gsap.timeline({
          defaults: { ease: 'power2.out' },
          onComplete: function () {
            gsap.set(rise, { clearProps: 'opacity,transform' });
            lockHeight(section);
          }
        });

        if (brand) {
          tl.to(brand, { opacity: 1, y: 0, duration: 0.85 }, 0.18);
        }

        if (titleAr) {
          tl.to(titleAr, { opacity: 1, y: 0, duration: 0.7 }, 0.42);
        }
        if (subtitle) {
          tl.to(subtitle, { opacity: 1, y: 0, duration: 0.65 }, 0.54);
        }
        if (desc) {
          tl.to(desc, { opacity: 1, y: 0, duration: 0.75 }, 0.66);
        }

        if (price) {
          tl.to(price, { opacity: 1, y: 0, duration: 0.65 }, 0.82);
        }
        if (bnpl) {
          tl.to(bnpl, { opacity: 1, y: 0, duration: 0.65 }, 0.94);
        }
        if (cta) {
          tl.to(cta, { opacity: 1, y: 0, duration: 0.6 }, 1.02);
        }
      });
    }, section);

    section._hero361Ctx = ctx;

    if (!section._hero361ResizeBound) {
      section._hero361ResizeBound = true;
      var resizeTimer;
      window.addEventListener('orientationchange', function () {
        window.setTimeout(function () {
          lockHeight(section);
        }, 250);
      });
      window.addEventListener('resize', function () {
        // Ignore mobile toolbar resizes (height-only); relock on real width changes.
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          var w = window.innerWidth;
          if (section._hero361Width && Math.abs(section._hero361Width - w) < 2) return;
          section._hero361Width = w;
          lockHeight(section);
        }, 150);
      });
      section._hero361Width = window.innerWidth;
    }
  }

  var HERO_SEL = '.hero361, .heroDrNight';

  function boot() {
    whenGsap(function (gsap) {
      document.querySelectorAll(HERO_SEL).forEach(function (section) {
        initSection(section, gsap);
      });
    });
  }

  ready(boot);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    if (!root || !root.querySelector) return;
    var section = root.matches && root.matches(HERO_SEL)
      ? root
      : root.querySelector(HERO_SEL);
    if (!section) return;
    section._hero361Done = false;
    section.setAttribute('data-hero-pending', '');
    boot();
  });
})();
